// import { fontGrid } from "@mui/material/styles/cssUtils";
// import ObjectMenu from "../draw/ObjectMenu";
import HaspObject from "../Hasp/HaspObject";

function findHaspObjectByType(objects, type) {
    var foundObjects = [];
    objects.getChildren().forEach(element => {
        if (element instanceof HaspObject) {
            if (element.isType(type)) {
                foundObjects.push(element);
            }
            if (element.isContainer()) {
                // Use spread operator to append results of recursive call
                foundObjects.push(...findHaspObjectByType(element, type));
            }
        }
    });
    return foundObjects;
}

/**
 *  check if the source is a parent of the target
 * 
 * @param {*} target 
 * @param {*} source 
 * @returns 
 */
function isChild(target, source) {
    const tparent = target.getParent();
    if (tparent._id === source._id) return true;
    if (tparent instanceof HaspObject)
        return isChild(tparent, source);
    return false;
}

/**
 * get an objects parent until we reach its page parent
 * return undefined if the object is an object menu
 * @param {*} object 
 * @returns object
 */
function getObjectPage(object) {
    if (object === null || object === undefined) return undefined;
    if (object instanceof HaspObject) {
        if (object.obj === 'page' || object.obj === 'template_page') {
            return object;
        }
        return getObjectPage(object.parent);
    } else {
        if (object.obj === 'object_menu') {
            return undefined;
        }
        return getObjectPage(object.parent);
    }
}

function escapeCString(unescaped) {
    let result = '"';

    for (let i = 0; i < unescaped.length; i++) {
        const ch = unescaped[i];
        if (ch == '"') {
            result += '\\"';
        } else if (ch == "\n") {
            result += "\\n";
        } else if (ch == "\r") {
            result += "\\r";
        } else if (ch == "\t") {
            result += "\\t";
        } else if (
            ch == "\\" &&
            (i + 1 == unescaped.length ||
                (unescaped[i + 1] != "n" &&
                    unescaped[i + 1] != "r" &&
                    unescaped[i + 1] != "t" &&
                    unescaped[i + 1] != "u"))
        ) {
            result += "\\\\";
        } else {
            result += ch;
        }
    }

    result += '"';

    return result;
}

function unescapeCString(escaped) {
    let result = "";

    for (let i = 0; i < escaped.length; i++) {
        if (escaped[i] == "\\") {
            if (i + 1 < escaped.length) {
                if (escaped[i + 1] == "n") {
                    result += "\n";
                    i += 1;
                    continue;
                }

                if (escaped[i + 1] == "r") {
                    result += "\r";
                    i += 1;
                    continue;
                }

                if (escaped[i + 1] == "t") {
                    result += "\t";
                    i += 1;
                    continue;
                }

                if (escaped[i + 1] == "u" && i + 5 < escaped.length) {
                    result += String.fromCharCode(
                        parseInt(escaped.substring(i + 2, i + 6), 16)
                    );
                    i += 5;
                    continue;
                }
            }
        }

        result += escaped[i];
    }

    return result;
}

function parseUnicodeNotation(unicode) {
    // Only process if a Unicode escape sequence is found
    if (/\\u[\dA-Fa-f]{4}/.test(unicode)) {
        return unicode.replace(/\\u([\dA-Fa-f]{4})/g, (_, code) => {
            return String.fromCharCode(parseInt(code, 16));
        });
    }
    return unicode;
}

export { findHaspObjectByType, isChild, getObjectPage, escapeCString, unescapeCString, parseUnicodeNotation };